import { getCmsOffers } from "../../../app/api/getCmsOffers";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  ICmsOffers,
  ICmsOffersResponse,
} from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsOffersAction extends BaseAction<ICmsOffers[], void> {
  override async run(): Promise<ICmsOffers[] | null> {
    let listOfOffers: ICmsOffers[] = [];
    try {
      const response: IApiResponse<ICmsOffersResponse> = await getCmsOffers();

      if (response.status === "ok" && response.answer) {
        const offers = response.answer.data;
        if (offers.length > 0) {
          listOfOffers = offers;
          updateRecoilState("cmsOfferListAtom", listOfOffers);
        } else {
          console.warn("No Offers available.");
        }
      } else {
        console.warn("Failed to fetch Offers.");
      }
    } catch (error: any) {
      console.error("Error fetching Offers:", error);
    } finally {
      return listOfOffers;
    }
  }
}

export const getCmsOffersAction = new GetCmsOffersAction();
